// src/api/fellowApi.js
// Fellow meeting data — served from blob cache, fetched from MCP on first view
import apiClient from "./apiClient";

export async function getFellowStatus() {
  try {
    const r = await apiClient.get("/api/ai/fellow/status");
    return r.data?.connected || false;
  } catch { return false; }
}

// Get meeting list — served from cache, refreshes if stale
export async function getFellowMeetings(limit = 20, forceRefresh = false) {
  const r = await apiClient.get(
    `/api/ai/fellow/meetings?limit=${limit}${forceRefresh ? "&refresh=true" : ""}`
  );
  return r.data?.meetings || [];
}

// Get full meeting detail — cached after first fetch
export async function getFellowMeetingNotes(id, title, forceRefresh = false) {
  const r = await apiClient.get(
    `/api/ai/fellow/meetings/${id}?title=${encodeURIComponent(title || id)}${forceRefresh ? "&refresh=true" : ""}`
  );
  return r.data?.meeting || null;
}

// Annotate a cached meeting (mark todos extracted, add notes, mark reviewed etc.)
export async function annotateFellowMeeting(id, annotations) {
  try {
    const r = await apiClient.patch(`/api/ai/fellow/meetings/${id}/annotate`, annotations);
    return r.data?.ok || false;
  } catch { return false; }
}
